<div *ngIf="!isEdited" class="cell-view gap-2">
  <div *ngIf="!!value?.icon && showIcon" style="width: 30px" [pTooltip]="showLabel ? null : value?.name">
    <i class="text-2xl" [class]="value?.icon" [style.color]="value?.color"></i>
  </div>
  <div *ngIf="showLabel" class="inner-view">{{ value?.name }}</div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="DropdownCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && value != null"
      id="cancelRowSelection"
      data-cy="DropdownCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup">
    <jml-lib-dropdown-input
      jmlStopClickPropagation
      jmlAutoFocus
      [control]="newValue"
      [(selectedEntry)]="selectedEntry"
      [options]="options"
      [placeholder]="value ? value._repr_ : header"
      [showLabel]="showLabel"
      [showIcon]="showIcon"
      [showTooltip]="showTooltip"
      (onClickOutside)="abortCellEdit($event)"
      (onEscape)="abortCellEdit($event)"
      (onUpdate)="save()"
      class="dropdown-full-width"
      appendTo="body"
    >
    </jml-lib-dropdown-input>
  </div>
</ng-template>
